export const environment = {
  production: true,
  backendUrl: 'https://swapxbackend.fly.dev',
  defaultTaker: '0xBb84a45bB54c2a37FA69056139d3F30f9734DcF5',
  firebase: {
    apiKey: "AIzaSyAzuCQCWJZv_nME5-2mg1kaQhGKTD2vcbU",
    authDomain: "smartswap-b175e.firebaseapp.com",
    projectId: "smartswap-b175e",
    storageBucket: "smartswap-b175e.firebasestorage.app",
    messagingSenderId: "434102774250",
    appId: "1:434102774250:web:043c08762efbec05b2ea93",
    vapidKey: "BHWVjH7PW8EP-sYaY2hh4gL1aNmM9lat9OhNdBsewx0hITKXoGssv6D-EMGtQFotWhl_UQa-VG0M27B3UwlisVI"
  }
};

